export function nodesToKmph(value: number | string): number {
  return parseFloat(value.toString()) * 1.852 ;
}

export function kmphToNodes(value: number | string): number {
  return parseFloat(value.toString()) / 1.852 ;
}
